import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const exporting = (state = initialState.exporting, action) => {
  switch (action.type) {
    case types.EXPORTING:
      return action.exporting;

    default:
      return state;
  }
};

export const exported = (state = initialState.exported, action) => {
  switch (action.type) {
    case types.EXPORT_SUCCESS:
      return action.data;

    case types.CLEAR_EXPORTED:
      return null;

    default:
      return state;
  }
};
